import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { Documento } from '../models/documento.model';
interface Documento {
  id: string;
  nome: string;
  description: string;
}
@Injectable({
  providedIn: 'root',
})
export class DocumentoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all documentos
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: Documento[] }>(
        `${this.path}/getAllDocumento`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response));
  }

  // Get documento by ID
  public show(id: string): Observable<Documento> {
    return this.apiService
      .get<{ object: Documento }>(`${this.path}/getDocumentoById/${id}`)
      .pipe(map((response) => response.object as Documento));
  }

  // Create new documento
  public store(form: Documento): Observable<Documento> {
    const documento = form as Documento;
    return this.apiService
      .post<{ object: Documento }>(`${this.path}/AddDocumento`, documento)
      .pipe(map((response) => response.object as Documento));
  }

  // Update existing documento
  public update(form: FormGroup, id: string): Observable<Documento> {
    const documento = form.value as Documento;
    return this.apiService
      .put<{ object: Documento }>(
        `${this.path}/UpdateDocumento/${id}`,
        documento
      )
      .pipe(map((response) => response.object as Documento));
  }

  // Delete existing documento
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteDocumentoById/${id}`);
  }
}
